import React, { useState, useEffect } from "react";
import Header1 from "../seperate Components/Header1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPhone } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Footer";
import { ServiceBanner } from "../seperate Components/ServiceBanner";
import "../../Styles/seperate Comp Css/CaseStudy.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import Spinner from "../seperate Components/Spinner";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import { Helmet } from "react-helmet";
import config from "../../config";
const corebanking = () => {
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  return (
    <div>
      <Helmet>
        <title>Project One</title>
      </Helmet>

      <Header1 />

      {/* Banner section */}
      {/* <div
        className="bd-page-title-area bd-page-title-bg_career pt-120 pb-20 main-heading"
        
      > */}
              <div
        className=" pt-120 pb-20 comp-heading"
        
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bd-page-title text-center z-index">
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "38px", color: "#01536E" }}
                >
                  Case Studies
                </h2>
                {/* <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      How We Help Your Business to get Automised and Succeed!
                    </p>
                  </nav>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="bd-service-details-area pt-80 pb-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-lg-8 case-study-section">
              <div className="bd-service-details">
                <div className="bd-service-details-img ">
                  {/* <img
                    src={studies.detailed_image}
                    className="main-image1"
                    alt="img not found"
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bd-service-area  caseStudyB2">
        <div className="container text-center" style={{ maxWidth: "1270px" }}>
          {/* <div className="row">
            <div className="col-lg-12 col-md-6 bd-case-studies-section1">
              <div className="bd-service1- mb-30">
                <h4 className="bd-service-title mb-20">
                  Core Banking Transformation for a NBFC
                </h4>
                <p></p>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-lg-8 col-md-6 bd-case-studies-section2">
              <div className="bd-service1-">
                <h4 className="bd-service-title mb-20">
                  It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something more. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference. Don't worry about sounding professional. Sound like you. There are over 1.5 billion websites out there, but your story is what's going to separate this one from the rest. If you read the words back and don't hear your own voice in your head, that's a good sign you still have more work to do.

                </h4>
                <ul className="mb-45" style={{ listStyle: "none" }}>
                  <li className="case-point-sec pb-10"></li>
                </ul>
              </div>
            </div>
            <div className="col-md-2"></div>

          </div>
        </div>
      </section>

      <div className="case-studie-button pb-80">
        <Link to={`${config.appurl}case-studies`} onClick={toggleContact}>
          <button className="get-start size-button">
            View More case Studies
          </button>
        </Link>
      </div>
      {/* <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for Business Automation Expert?
                </h2>
                <p className="contact_section second-para-resp">
                  You're at the right place. The right time
                </p>
                <p className="contact_subtext">
                  Surprisingly great results achieved, Let's get started right
                  now !
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:(+91)720-288-2277"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    (+91) 720-288-2277
                  </a>
                </div>
              </div>
              <Link to={"/zithas/contact-us"} onClick={toggleContact}>
                    <button className="touch-btn1 mt-20">Get Started</button>
                    </Link>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default corebanking;
